module.exports = __webpack_public_path__ + "img/upper_pocket_width.65b0975d.png";